<template>
  <header class="app-header">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="col-12 px-3">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navigation-bar"
          aria-controls="navigation-bar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navigation-bar">
          <router-link class="navbar-brand" to="/">
            <img
              :src="logoUrl"
              height="50"
              alt="logo"
            >
          </router-link>
          <ul class="navbar-nav mr-auto"  v-if="userRole">
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: active === 'search' }"
                to="/search"
              >
                Catalog
              </router-link>
            </li>
             <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: active === 'orders' }"
                to="/orders"
              >
                Orders
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: active === 'invoices' }"
                to="/invoices"
              >
                Invoices
              </router-link>
            </li>
            <li class="nav-item"  v-if="$can('reports_dashboard')">
              <router-link
                class="nav-link"
                :class="{ active: active === 'reports' }"
                to="/reports"
              >
                Reports
              </router-link>
            </li>
            <li class="nav-item"
            v-if="$can('user_dashboard')">
              <router-link
                class="nav-link"
                :class="{ active: active === 'users' }"
                to="/users"
              >
                Users
              </router-link>
            </li>
            <li class="nav-item"
            v-if="$can('facility_dashboard')">
              <router-link
                class="nav-link"
                :class="{ active: active === 'facilities' }"
                to="/facilities"
              >
                Facilities
              </router-link>
            </li>
            <li class="nav-item"
            v-if="$can('settings_dashboard')">
              <router-link
                class="nav-link"
                :class="{ active: active === 'settings' }"
                to="/settings"
              >
                Settings
              </router-link>
            </li>
          </ul>


          <ul class="navbar-nav">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="username" id="userEmail">{{userEmail}}</span>
                  <span class="caret"></span>
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link
                    class="dropdown-item"
                    to="/Profile"
                  >
                    <span class="fa fa-user-cog"></span> Edit Profile
                  </router-link>
                  <router-link
                    v-if="$can('basic_settings')"
                    class="dropdown-item"
                    to="/basic-settings"
                  >
                    <span class="fa fa-gear"></span> Basic Settings
                  </router-link>
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item"  @click="onLogout">
                    <span class="fas fa-sign-out-alt"></span> Sign Out
                  </a>
              </div>
            </li>
            <li class="navbar-item">
              <router-link
                class="nav-link cart-link"
                :class="{ active: active === 'cart' }"
                to="/shopping-cart"
              >
                <span class="fa fa-shopping-cart"></span>
                <span class="cart-item-count ml-1" id="itemCount"  v-if="cartItems.length > 0">{{ cartItems.length }}</span>
               </router-link>
            </li>
          </ul>


          
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'


export default defineComponent({
  name: 'AppHeader',
  props: {
    active: {
      type: String,
      default: '',
    },
    showLogout: {
      type: Boolean,
      default: true,
    },
    // logoUrl: {
    //   type: String,
    //   default: 'https://platform.flight-line.com/api/Marketplaces/Logo/DEMOMED/Flightline-FullColor-Icon-RGB.png',
    // },

  },
  
  setup () {
    const store = useStore()
    const router = useRouter()
    const user = JSON.parse(localStorage.getItem('user'))
    const userEmail = user?.email

    const cartItems = computed(() => store.getters['cart/cartItems'])
    const userRole = computed(() => store.getters['users/role'])
    
    async function onLogout () {
      await localStorage.removeItem('auth_token')
      await localStorage.removeItem('token')
      await localStorage.removeItem('current_account_id')
      store.dispatch('users/resetUserProfile')
      store.dispatch('auth/logout')
      router.push('/login')
    }


    store.dispatch('cart/fetchCart')

    const branding = computed(() => store.getters['settings/branding'])
    const logoUrl = computed(() => 
      branding.value?.branding_logo || '/Flightline-FullColor-Stacked-Logo-RGB.png'
    )

    return { onLogout, userEmail ,cartItems, userRole, logoUrl}
  },
})
</script>
<style scoped>
.nav-link.router-link-exact-active {
  color: #fff !important;
}
.nav-link.active {
  color: #fff !important;
}
</style>

